import script from "./VSocialSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./VSocialSelect.vue?vue&type=script&lang=ts&setup=true"

import "./VSocialSelect.vue?vue&type=style&index=0&id=356f94fa&lang=sass"

const __exports__ = script;

export default __exports__